export default "__VITE_ASSET__CTWdyZS3__"